import React, { Component } from "react";
import { Button, FormGroup, Label } from "reactstrap";
import { toast } from "react-toastify";
import { isObject } from "lodash";
import DropDown from "./DropDown";
import { GetBaseDownloadUrl } from "./helper";
import Loading from "../pages/Loading";

export default class TopBar extends Component {
  state = {
    loading: false,
    brands: [],
    formattedBrand: null,
    markets: [],
    formattedMarket: null,
    languages: [],
    formattedLanguage: null,
    isButtonLoading: false
  };

  componentDidMount = () => {
    const { access, brand, market, language } = this.props;
    this.loadDropDownStates(access, brand, market, language);
  };

  downloadBase = () => {
    const { formattedBrand, formattedMarket } = this.state;
    this.setState({ isButtonLoading: true });
    GetBaseDownloadUrl(formattedBrand.value, formattedMarket.value)
      .then(url => {
        window.open(url, "_blank");
        this.setState({ isButtonLoading: false });
      })
      .catch(err => {
        this.setState({ isButtonLoading: false });
        toast.error(err.message);
      });
  };

  loadDropDownStates = (access, brand, market, language) => {
    if (!access || !brand || !market || !language) return;

    const brands = [];
    let formattedBrand = null;
    const markets = [];
    let formattedMarket = null;
    const languages = [];
    let formattedLanguage = null;

    access.forEach(rootItem => {
      brands.push({ label: rootItem.brandDisplay, value: rootItem.brand });
      if (rootItem.brand === brand) {
        formattedBrand = { label: rootItem.brandDisplay, value: rootItem.brand };
        rootItem.markets.forEach(marketItem => {
          markets.push({ label: marketItem.marketDisplay, value: marketItem.market });
          if (marketItem.market === market) {
            formattedMarket = { label: marketItem.marketDisplay, value: marketItem.market };
            marketItem.languages.forEach(languageItem => {
              let languageObject = {};
              if (isObject(languageItem))
                languageObject = { label: languageItem.languageDisplay, value: languageItem.language };
              else languageObject = { label: languageItem, value: languageItem };
              languages.push(languageObject);
              if (languageItem.language === language || languageItem === language) formattedLanguage = languageObject;
            });
          }
        });
      }
    });

    this.setState({ brands, formattedBrand, markets, formattedMarket, languages, formattedLanguage });
  };

  render() {
    const {
      radioSelectedStatus,
      radioClickedStatus,
      radioClickedBrand,
      radioClickedMarket,
      radioClickedLanguage,
      canDownloadBase
    } = this.props;

    const {
      loading,
      brands,
      formattedBrand,
      markets,
      formattedMarket,
      languages,
      formattedLanguage,
      isButtonLoading
    } = this.state;

    if (loading) {
      return <Loading />;
    }

    return (
      <div style={{ paddingLeft: "20px" }}>
        <div style={{ display: "flex" }}>
          <div style={{ marginTop: "5px", padding: "5px" }}>
            <DropDown options={brands} selected={formattedBrand} Clicked={radioClickedBrand} label="Brand" />
          </div>
          <div style={{ marginTop: "5px", padding: "5px" }}>
            <DropDown options={markets} selected={formattedMarket} Clicked={radioClickedMarket} label="Market" />
          </div>
          <div style={{ marginTop: "5px", padding: "5px" }}>
            <DropDown
              options={languages}
              selected={formattedLanguage}
              Clicked={radioClickedLanguage}
              label="Language"
            />
          </div>

          <div style={{ marginTop: "5px", marginLeft: "10px", padding: "5px" }}>
            <DropDown
              options={[{ label: "Saved", value: "Saved" }, { label: "Published", value: "Published" }]}
              selected={radioSelectedStatus}
              Clicked={radioClickedStatus}
              label="Status"
            />
          </div>
          {canDownloadBase && (
            <div style={{ marginTop: "5px", marginLeft: "10px", padding: "5px" }}>
              <FormGroup>
                <Label>Download Base</Label>
                <br />
                <Button disabled={isButtonLoading} onClick={!isButtonLoading ? this.downloadBase : null}>
                  {isButtonLoading ? "Loading..." : "Download Base"}
                </Button>
              </FormGroup>
            </div>
          )}
        </div>
      </div>
    );
  }
}
